import React from 'react';

import { Outlet } from 'react-router-dom';

const ExcessReturnContent = () => {
  return <Outlet />;
};

export default ExcessReturnContent;
